const SAMPLE = {
  TEST: 'Test',
  TEST1: 'Test1',
  TEST2: 'Test2',
};

const API_RESPONSE_MESSAGE = {
  UNAUTHORIZED: 'Unauthorized',
  SUCCESS: 'success',
};

const API_RESPONSE_STATUS = {
  SUCCESS: '200',
  BAD_REQUEST: '400',
  UNAUTHORIZED: '401',
  FORBIDDEN: '403',
  NOT_FOUND: '404',
  INTERNAL_SERVER_ERROR: '500',
};

const THUMB_TYPE = {
  UP: 'up',
  DOWN: 'down',
};

const EXPORT_TYPE = {
  PDF: 'pdf',
  TXT: 'txt',
};

const UI_STAFF = 'TGStaff@2025';

const MAX_RECORD_SEC = 300;

export const ENUM = {
  SAMPLE,
  API_RESPONSE_MESSAGE,
  THUMB_TYPE,
  EXPORT_TYPE,
  API_RESPONSE_STATUS,
  UI_STAFF,
  MAX_RECORD_SEC,
};
